module.exports = __webpack_public_path__ + "img/giftbox.2ff84e86.png";